module.exports = __webpack_public_path__ + "static/media/splash1_1x.0d9c7bd6.jpg";